import { render } from "./DashboardCard.vue?vue&type=template&id=69a6bc6a&scoped=true"
const script = {}

import "./DashboardCard.vue?vue&type=style&index=0&id=69a6bc6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a6bc6a"]])

export default __exports__